<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Background Image</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <img v-if="dataImg" :src="dataImg" alt="" width="350px" height="200px"><br>
       <vs-button color="primary" @click.native="toggleImageSidebar(true)"
                  >Upload Image</vs-button>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="createImg">Submit</vs-button>         
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
     <image-library-sidebar
      @setImg="setImg"
      :isSidebarActive="ImageViewSidebar"
      @closeSidebar="toggleImageSidebar"
    />
  </vs-sidebar>
  
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ImageLibrarySidebar from "../ImageLibrarySidebar.vue";
import {} from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: String,
    }
  },
  components: {
    "image-library-sidebar": ImageLibrarySidebar,
    VuePerfectScrollbar
  },
  data () {
    return {
      dataImg:null,
      ImageViewSidebar: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if(val){
        this.dataImg=this.data
      }
    
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()  
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    createImg(){
      if(this.dataImg){
      this.$emit('setBgimg',this.dataImg)
      }
    },
    setImg(val){
        this.dataImg=val
    },
    toggleImageSidebar(val = false) {
      this.ImageViewSidebar = val;
    }, 
    alertNofity (color,text) {
      this.$vs.notify({
        color: color,
        title: "Page",
        position: 'top-right',
        text: text
      })
    },
    initValues () {
      
  
    },

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
